var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-box"},[_c('div',{staticClass:"title"},[_vm._v("多日血糖曲线")]),_c('div',{staticStyle:{"width":"100%","height":"22rem"},attrs:{"id":"weeklySugar"}})])
}]

export { render, staticRenderFns }